import { useEffect, useState } from "react";
import { Outlet } from "react-router";
import { noop } from "es-toolkit";

import { useGetMe } from "api/users/users";

import {
  isPendingApprovalResponse,
  toUserFromMeResponse,
  UserContext,
  type UserContext as UserContextType,
} from "./hooks";

const defaultContext: UserContextType = {
  isPending: true,
  isPendingApproval: false,
  refetch: noop,
};

const UserProvider: React.FC = () => {
  const [userContext, setUserContext] =
    useState<UserContextType>(defaultContext);

  const { data, isError, isPending, refetch } = useGetMe({
    query: {
      refetchInterval: 10_000,
      retry: false,
    },
  });

  useEffect(() => {
    if (data) {
      setUserContext((ctx) => ({
        ...ctx,
        isPendingApproval: isPendingApprovalResponse(data),
        user: toUserFromMeResponse(data),
      }));
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      setUserContext((ctx) => ({
        ...ctx,
        isPending: false,
        isPendingApproval: false,
        user: undefined,
      }));
    }
  }, [isError]);

  useEffect(() => {
    setUserContext((ctx) => ({ ...ctx, isPending }));
  }, [isPending]);

  useEffect(() => {
    setUserContext((ctx) => ({ ...ctx, refetch }));
  }, [refetch]);

  return (
    <UserContext value={userContext}>
      <Outlet />
    </UserContext>
  );
};

export default UserProvider;
